import React from 'react'
import _ from 'lodash'
import ShowtimeType from './ShowtimeType'

export default class ShowtimeTypeList extends React.Component {

    render() {
        const { types } = this.props;
      
        return (
            <div className="ShowtimeTypeList">
                {_.map(types, (type) =>  <ShowtimeType key={type.id} type={type} includeName={true} />)}
            </div>
        )
    }
}